<template>
  <tg-card
    dense
    v-bind="$attrs"
    :no-padding="noPadding"
  >
    <template
      v-if="showHeading"
      #header
    >
      <h3 v-text="cardTitle" />
    </template>

    <tg-login-form
      v-if="mode === 'login'"
      v-bind="loginSettings"
      :show-field-vertical="showFieldVertical"
      @go-to-forgot-password="mode = 'forgot-password'"
    />
    <tg-forgot-password-form
      v-else
      v-bind="forgotPasswordSettings"
      @go-to-login="mode = 'login'"
      @go-to-register="$emit('register')"
    />
  </tg-card>
</template>

<script>
import TgLoginForm from '../common/form/TgLoginForm';
import TgForgotPasswordForm from '../common/form/TgForgotPasswordForm';

import loginMixin from '~/mixins/loginMixin';
import TgCard from '~/components/common/card/TgCard.vue';

export default {
  name: 'TgCompleteLogin',

  components: {
    TgCard,
    TgForgotPasswordForm,
    TgLoginForm,
  },

  mixins: [loginMixin],

  props: {
    displayMode: {
      type: String,
      default: 'login',
    },
    showFieldVertical: {
      type: Boolean,
      default: false,
    },
    showHeading: {
      type: Boolean,
      default: true,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      mode: this.displayMode,
      username: null,
      password: null,
    };
  },

  computed: {
    cardTitle () {
      if (this.mode === 'login') {
        return this.$t('text.account.login');
      }

      return this.$t('text.account.set_password');
    },
  },
};
</script>
